import axios from 'axios';

export const state = {
    all: [],
    // allMXN: [],
}

export const getters = {
    getAll: (state) => state.all,
    // getAllMXN: (state) => state.allMXN,
}

export const actions = {
    // async fetchAll({ commit }) {
    //     const response = await axios.get(`/states/all`);
    //     commit('SET_ALL', response.data);
    // },
    async fetchAll({ commit }) {
        const response = await axios.get(`/states/all/country/145`);
        commit('SET_ALL', response.data);
    },
    async fetchAllCountry({ commit }, data) {
        const response = await axios.get(`/states/all/country/${data.country}`);
        commit('SET_ALL', response.data);
    }
}


export const mutations = {
    SET_ALL: (state, result) => state.all = result,
    // SET_ALL_MXN: (state, result) => state.allMXN = result,
}